import { useState, useEffect } from 'react';
import { gymsApi } from '../api/gyms.api.js';
import type { Gym } from '@atomfit/shared';

export function useGyms() {
  const [gyms, setGyms] = useState<Gym[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    gymsApi
      .list()
      .then((res) => setGyms(res.data.data))
      .catch((err: Error) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return { gyms, loading, error };
}
